<template>
    <div id="scheduling-pendencies" data-testid="scheduling-pendencies">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <p class="mb-0 text-muted">
                Mentorados individuais com crédito (ou agenda livre) e sem sessão futura.
            </p>
            <b-button
                size="sm"
                variant="outline-primary"
                data-testid="pendencies-refresh"
                :disabled="loading"
                @click="fetchPendencies"
            >
                Atualizar
            </b-button>
        </div>

        <div class="alert alert-info" v-if="!loading && !items.length" data-testid="pendencies-empty">
            Nenhuma pendência de agendamento no momento.
        </div>

        <div class="table-responsive" v-if="items.length">
            <table class="table table-bordered table-hover" data-testid="pendencies-table">
                <thead>
                <tr>
                    <th>Mentorado</th>
                    <th>Mentoria</th>
                    <th>Modo</th>
                    <th>Créditos</th>
                    <th style="width: 160px">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.enrollment_id">
                    <td>
                        <strong>{{ item.mentee_name }}</strong>
                        <small class="d-block text-muted">{{ item.mentee_email }}</small>
                    </td>
                    <td>{{ item.mentoring_title }}</td>
                    <td>
                        <span v-if="item.session_mode === 'fixed'">Fixa</span>
                        <span v-else>Livre</span>
                    </td>
                    <td data-testid="pendency-credits">
                        <span v-if="item.session_mode === 'fixed'">
                            {{ item.sessions_remaining }} restantes
                            ({{ item.sessions_used }}/{{ item.sessions_quota }})
                        </span>
                        <span v-else class="text-muted">Ilimitado</span>
                    </td>
                    <td>
                        <router-link
                            class="btn btn-sm btn-outline-primary"
                            :to="`/mentorias/detalhes/${item.mentoring_id}/mentorando/${item.mentee_id}`"
                            data-testid="pendency-open-mentee"
                        >
                            Ver mentorado
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import http from "@/http";
import {endLoading, startLoading} from "@/components/composables/spinners";

export default {
    name: 'SchedulingPendencies',

    data() {
        return {
            items: [],
            loading: false,
        };
    },

    mounted() {
        this.fetchPendencies();
    },

    methods: {
        fetchPendencies() {
            this.loading = true;
            startLoading('scheduling-pendencies');
            http.get('mentor/scheduling-pendencies')
                .then((response) => {
                    this.items = Array.isArray(response.data) ? response.data : [];
                })
                .catch((e) => {
                    console.error(e);
                    this.$notifyError(e.response?.data?.message || e.response?.data || e);
                    this.items = [];
                })
                .finally(() => {
                    this.loading = false;
                    endLoading('scheduling-pendencies');
                });
        },
    },
};
</script>
